import React, { useEffect, useState, useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import Button from "@material-ui/core/Button";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Icon from "@material-ui/core/Icon";
import * as CLASS from "../../services/class";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import { defaultFont } from "assets/jss/material-dashboard-react.js";
import TablePagination from "@material-ui/core/TablePagination";
import { Router, Route, Redirect } from "react-router-dom";
import { themeColor } from "../../assets/jss/material-dashboard-react.js";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import defaultCover from "assets/img/default_cover.png";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Swal from "sweetalert2";

const styles = makeStyles(theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  table: {
    width: "100%",
    overflowX: "auto"
  },
  th: {
    color: themeColor,
    ...defaultFont,
    padding: 4,
    textAlign: "left",
    fontSize: 15.5,
    fontWeight: "400"
  },
  td: {
    ...defaultFont,
    paddingTop: 8,
    paddingBottom: 8,
    // border: '1px solid #ddd',
    padding: 6
  },
  tr: {
    "&:nth-child(even)": {
      backgroundColor: "#f7f7f7"
    },
    "&:hover": {
      backgroundColor: "#e6e6e6",
      cursor: "pointer"
    }
  },
  load: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#AAAAAA !important",
      borderWidth: "1px !important"
    },
    "&:after": {
      borderColor: themeColor
    }
  },
  disabled: {
    "&:before": {
      backgroundColor: "transparent !important"
    }
  },
  cssLabel: {
    "&$cssFocused": {
      color: themeColor
    }
  },
  cssFocused: {},
  select: {
    marginTop: theme.spacing(3),
    "&:after": {
      borderColor: themeColor
    },
    "&:hover:not($disabled):before": {
      borderColor: themeColor
    }
  }
}));

const useStyles = styles;
const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.8 + ITEM_PADDING_TOP
    }
  }
};

export default function Class(props) {
  const classes = useStyles();
  const [isLoggedIn,setLoggedIn] = useState(true);
  const [indexNumber, setIndexNumber] = useState([]);
  const [classList, setClassList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSortType, setSelectedSortType] = useState("-- Select --");
  const [selectedStatus, setSelectedStatus] = useState("-- Select --");
  const [selectedSortby, setselectedSortby] = useState("-- Select --");
  const [bundleOnly, setBundleOnly] = useState(false);
  const [pagination, setPagination] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(
    props.location.state && props.location.state.currentPage ? props.location.state.currentPage : 1
  );
  const [searchInput, setSearchInput] = useState("");
  const [onFilter, setOnFilter] = useState("");
  const [route, setRoute] = React.useState({});
  const [pageArr, setPageArr] = React.useState([]);
  let myRef;

  const routeTo = (action, id) => {
    setRoute({ action: action, id: id });
  };

  const goToPage = e => {
    setCurrentPage(e.target.value);
    setTimeout(() => {
      document.getElementById("table").scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }, 500);
  };

  useEffect(() => {
    let params = {};
    if (onFilter) {
      if (searchInput.length > 0) {
        params.search = searchInput;
      }
      if (selectedSortby != "-- Select --") {
      params.sortBy = selectedSortby;
      }
      if (selectedStatus != "-- Select --") {
      params.status = selectedStatus;
      }
      if (selectedSortType != "-- Select --") {
        params.sortType = selectedSortType;
      }
    }

    if (props.location.state) {
      if (props.location.state.search) {
        params.search = props.location.state.search;
        setSearchInput(params.search);
        props.location.state.search = null;
      }
      if (props.location.state.sortBy) {
        params.sortBy = props.location.state.sortBy;
        setselectedSortby(params.sortBy);
        props.location.state.sortBy = null;
      }
      if (props.location.state.status == 1 || props.location.state.status == 2 || props.location.state.status == 3 || props.location.state.status == 4) {
        params.status = props.location.state.status;
        setSelectedStatus(params.status);
        props.location.state.status = null;
      }
      if (props.location.state.sortType == "asc" || props.location.state.sortType == "desc") {
        params.sortType = props.location.state.sortType;
        setSelectedSortType(params.sortType);
        props.location.state.sortType = null;
      }
    }
    props.history.replace({
      pathname: "/class",
      state: {}
    });

    
    CLASS.getClassList(currentPage, params)
      .then(res => {
        if (res.data) {
          let page = [];
          for (let i = 0; i < res.data.last_page; i++) {
            page.push(i + 1);
          }
          setPageArr(page);
        }

        let i = 1; 
        res.data.data.map(datum => {
            datum.indexNumber = (currentPage - 1 ) * 10 + i;
            i++;
            return datum;
        })

        setClassList(res.data.data);
        setPagination(res.data);
        setLoading(false);
      })
      .catch(err => {
        if (err === "token expired") {
          props.history.replace("/login");
        }
        if (err === "Unauthorized") {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Session expired. Please login again"
            })
            .then(() => {
              localStorage.removeItem('BZtokenData');
              setLoggedIn(false);      
            });
        }
      });
  }, [currentPage, onFilter]);

  if (!isLoggedIn) {
    return <Redirect from="/" to="/login" />;
  }

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
    myRef.scrollIntoView({
      behavior: "auto",
      block: "start"
    });
  };

  const handleSearchInput = event => {
    const options = event.target.value;
    setSearchInput(options);
  };

  const handleSortByChange = event => {
    const options = event.target.value;
    setselectedSortby(options);
  };
  
  const handleStatusChange = event => {
    const options = event.target.value;
    setSelectedStatus(options);
  };

  const handleSortTypeChange = event => {
    const options = event.target.value;
    setSelectedSortType(options);
  };

  const handleDelete = (event,classs) => {
    Swal.fire({
      title: 'Are you sure to delete this class?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    })
    .then((result) => {
      if (result.value) {
        const newClassList = [...classList];
        const index = newClassList.indexOf(classs);
        if (index !== -1) {
          newClassList.splice(index,1);
          setClassList(newClassList);
        }    
        CLASS.deleteClass(classs.id)   
        .then(res => {
          Swal.fire({
            icon: "success",
            title: "Class deleted successfully"
          }).then(() => {
            props.history.push("/class");
          });
        })
      } 
      else if (result.dismiss === Swal.DismissReason.cancel) {
        props.history.replace("/class");
      }
    })
    .catch(err => {
      if (err === "token expired") {
        props.history.replace("/login");
      }
      if (err === "Unauthorized") {
        Swal.fire({
          icon: "error",
          title: "Oops",
          text: "Session expired. Please login again"
          })
          .then(() => {
            localStorage.removeItem('BZtokenData');
            setLoggedIn(false);      
          });
      }
    });
  };

  const keyPress = e => {
    if (e.keyCode == 13) {
      filterThis();
    }
  };

  const filterThis = () => {
    setLoading(true);
    setCurrentPage(1);
    setOnFilter(searchInput + selectedSortby + selectedStatus + selectedSortType + new Date());
  };

  const clearFilter = () => {
    setLoading(true);
    setSearchInput("");
    setBundleOnly(false);
    setselectedSortby("-- Select --");
    setSelectedStatus("-- Select --");
    setSelectedSortType("-- Select --");
    setCurrentPage(1);
    setOnFilter(new Date());
  };

  const paramPass = {
    page: currentPage,
    search: searchInput,
    sortBy: selectedSortby,
    status: selectedStatus,
    sortType: selectedSortType

  };

  if (route.action == "add") {
    return (
      <Redirect
        to={{
          pathname: "/class/add",
          state: paramPass
        }}
      />
    );
  } else if (route.action == "view") {
    return (
      <Redirect
        to={{
          pathname: "/class/" + route.id,
          state: paramPass
        }}
      />
    );
  }

  return loading ? (
    <div className={classes.load}>
      <CircularProgress style={{ fontSize: 30, color: themeColor }} />
    </div>
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Button
            variant="contained"
            style={{ backgroundColor: themeColor, color: "white" }}
            className={classes.submit}
            onClick={() => routeTo("add")}>
            <Icon style={{ paddingRight: 2, fontSize: 19 }}>add</Icon>
          Add Class
        </Button>
        <div
          id="table"
          ref={node => {
            myRef = node;
          }}>
          <Card>
            <CardBody>
              <GridContainer style={{ paddingBottom: 10 }}>
                <GridItem xs={6} sm={5} md={3}>
                  <TextField
                    variant="standard"
                    margin="normal"
                    id="search"
                    label="Search"
                    name="search"
                    placeholder={"class name"}
                    fullWidth
                    onKeyDown={keyPress}
                    value={searchInput}
                    onChange={handleSearchInput}
                    InputProps={{
                      classes: {
                        underline: classes.underline,
                        disabled: classes.disabled
                      }
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.cssLabel,
                        focused: classes.cssFocused
                      }
                    }}
                  />
                </GridItem>
                {/* <GridItem xs={5} sm={4} md={5} style={{ marginTop: 10 }}>
                  Sort by :
                  <Select
                    style={{ marginLeft: 10 }}
                    className={classes.select}
                    id="type"
                    name="type"
                    variant="outlined"
                    value={selectedSortby}
                    onChange={handleSortByChange}
                    input={<Input id="type" />}
                    renderValue={selected =>
                      selected == 1 ? "Featured" : selected
                    }>
                    <MenuItem key={"all"} value={"-- Select --"}>
                      <ListItemText primary={"Unset"} />
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      <ListItemText primary={"Featured"} />
                    </MenuItem>
                  </Select>
                </GridItem> */}

                <GridItem xs={12} sm={5} md={3} style={{ marginTop: 10 }}>
                  Status :
                  <Select
                    style={{ marginLeft: 10 }}
                    className={classes.select}
                    id="status"
                    name="status"
                    variant="outlined"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                    renderValue={selected =>
                      selected == 1 ? "Pending" : selected == 2 ? "Published" : 
                      selected == 3 ? "Rejected" : selected == 4 ? "Removed" : selected
                    }>
                    <MenuItem key={"all"} value={"-- Select --"}>
                      <ListItemText primary={"All"} />
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      <ListItemText primary={"Pending"} />
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      <ListItemText primary={"Published"} />
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      <ListItemText primary={"Rejected"} />
                    </MenuItem>
                    <MenuItem key={4} value={4}>
                      <ListItemText primary={"Removed"} />
                    </MenuItem>
                  </Select>
                </GridItem>

                <GridItem xs={12} sm={5} md={3} style={{ marginTop: 10 }}>
                  Sort Type :
                  <Select
                    style={{ marginLeft: 10 }}
                    className={classes.select}
                    id="sorttype"
                    name="sorttype"
                    variant="outlined"
                    value={selectedSortType}
                    onChange={handleSortTypeChange}
                    renderValue={selected =>
                        selected == "asc" ? "Ascending" : selected == "desc" ? "Descending" : selected
                    }>
                      <MenuItem key={"all"} value={"-- Select --"}>
                        <ListItemText primary={"All"} />
                      </MenuItem>
                      <MenuItem key={1} value={"asc"}>
                        <ListItemText primary={"Ascending"} />
                      </MenuItem>
                      <MenuItem key={2} value={"desc"}>
                        <ListItemText primary={"Descending"} />
                      </MenuItem>                     
                  </Select>
                </GridItem>

                <GridItem xs={12} sm={5} md={3}
                  style={{ display: "block", marginTop: 25, textAlign: "right" }}>
                  <Button
                    variant="contained"
                    type="submit"
                    style={{ backgroundColor: themeColor, color: "white", marginBottom: 8 }}
                    className={classes.submit}
                    onClick={filterThis}>
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: themeColor,
                      color: "white",
                      marginLeft: 8,
                      marginBottom: 8
                    }}
                    className={classes.submit}
                    onClick={clearFilter}>
                    Reset
                  </Button>
                </GridItem>
              </GridContainer>
              {classList.length > 0 ? (
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.th}>#</TableCell>
                        <TableCell style={{ width: 50 }} className={classes.th}></TableCell>
                        <TableCell className={classes.th}>Name</TableCell>
                        <TableCell className={classes.th}>Retail Price</TableCell>
                        <TableCell className={classes.th}>Created At</TableCell>
                        <TableCell className={classes.th}>Type</TableCell>
                        {/* <TableCell className={classes.th}>Feature</TableCell> */}
                        <TableCell className={classes.th}>Status</TableCell>
                        <TableCell className={classes.th}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {classList.map(classs => (
                        <TableRow
                          onClick={() => routeTo("view", classs.id)}
                          className={classes.tr}
                          key={classs.id}>
                          <TableCell className={classes.td} component="th" scope="row">
                            {classs.indexNumber}
                          </TableCell>
                          <TableCell className={classes.td}>
                            <div style={{ borderRadius: 5, backgroundColor: '#ebebeb', overflow: 'hidden', width:70 }}>
                              <img
                                src={
                                  classs.images[0].url
                                    ? classs.images[0].url
                                    : classs.avatar
                                    ? classs.avatar
                                    : defaultCover
                                }
                                ali=""
                                // width="40"
                                height="40"
                                style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                              />
                            </div>
                          </TableCell>
                          <TableCell className={classes.td}>{classs.name}</TableCell>
                          <TableCell className={classes.td}>RM{classs.retail_price}</TableCell>
                          <TableCell className={classes.td}>
                            {classs.created_at.substring(0, 10) +
                              " " +
                              classs.created_at.substring(11, 19)}
                          </TableCell>
                          <TableCell 
                            style={{
                              color: 
                              classs.type.id == 1 ? "#1E90FF" : "#7B68EE" , 
                              fontWeight: "400"
                            }}
                            className={classes.td}>
                            {classs.type.name}
                            </TableCell>
                          {/* <TableCell
                              style={{
                                color: classs.is_feature == 1 ? "#4caf50" : "#f44336",
                                fontWeight: "400"
                              }}
                              className={classes.td}>
                              {classs.is_feature == 1 ? "Yes" : "No"}
                            </TableCell> */}
                          <TableCell
                            style={{
                              color: 
                              classs.status.id == 1 ? "#FFA500" :
                              classs.status.id == 2 ? "#4caf50" : 
                              classs.status.id == 3 ? "#FF0000" : "black", 
                              fontWeight: "400"
                            }}
                            className={classes.td}>
                            {classs.status.name}
                          </TableCell>
                          <TableCell>
                              <IconButton aria-label="delete"
                                  onClick={(event) => {handleDelete(event.stopPropagation(),classs) }} >
                                  <DeleteIcon />
                              </IconButton> 
                          </TableCell> 
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {classList.length > 0 ? (
                    <div
                      style={{ display: "inline-flex", width: "100%", justifyContent: "flex-end" }}>
                      <div style={{ fontSize: 13 }}>
                        Page :
                        <Select
                          style={{
                            marginLeft: 10,
                            width: 60,
                            fontSize: 13,
                            textAlign: "center",
                            marginTop: 12
                          }}
                          className={classes.select}
                          id="type"
                          name="type"
                          variant="outlined"
                          value={currentPage}
                          onChange={e => goToPage(e)}
                          input={<Input id="type" />}
                          renderValue={selected => selected}
                          MenuProps={MenuProps}>
                          {pageArr.map(page => (
                            <MenuItem key={page} value={page}>
                              <ListItemText primary={page} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <TablePagination
                        component="div"
                        rowsPerPageOptions={[]}
                        count={pagination.total}
                        rowsPerPage={10}
                        page={currentPage - 1}
                        onChangePage={handleChangePage}
                      />
                    </div>
                  ) : null}
                </div>
              ) : (
                <div style={{ paddingTop: 30, textAlign: "center" }}>
                  <Typography style={{ fontWeight: "inherit" }}>No Class found</Typography>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </GridItem>
    </GridContainer>
  );
}